<!-- @veltra/icons generated sha256:d5e5b547fcd1fa57 gen:8 source:src/svg/normal/pin.svg -->
<script setup lang="ts">
defineOptions({ name: 'Pin' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M12.518 1.34a.6.6 0 0 0-.811-.035L7.662 4.719l-.771-.771a.6.6 0 0 0-.849 0L3.937 6.052a.6.6 0 0 0 0 .849l1.867 1.867a.506.506 0 0 1 .01.712l-3.406 3.405a.5.5 0 0 0 .708.707c.776-.776 2.628-2.63 3.405-3.405a.506.506 0 0 1 .712.009l1.866 1.867a.6.6 0 0 0 .849 0l2.104-2.105a.6.6 0 0 0 0-.849l-.77-.77 3.413-4.046a.6.6 0 0 0-.034-.81zm-.127 1.287.982.982c.184.184.19.475.023.673l-3.174 3.76a.5.5 0 0 0 .027.678l.465.466c.196.195.197.5.001.695l-.844.845a.486.486 0 0 1-.696-.002l-3.9-3.899a.486.486 0 0 1 0-.696l.844-.844a.486.486 0 0 1 .695 0l.466.466a.5.5 0 0 0 .677.027l3.76-3.174a.496.496 0 0 1 .674.023"
    />
  </svg>
</template>
